import type { BaseUsecase } from '@usecases/base-usecase';
import type { PhoneCall } from '@salesforce/scv-connector-base';

export interface SupervisorDisconnectEventPublisher {
  publish(call: PhoneCall, callId: string, agentNumber: string): Promise<void>;
}

export interface SupervisorDisconnectRequest {
  call: PhoneCall;
  callId: string;
  agentNumber: string;
}

export interface SupervisorDisconnectUsecase
  extends BaseUsecase<SupervisorDisconnectRequest, void> {
  run(request: SupervisorDisconnectRequest): Promise<void>;
}

export class SupervisorDisconnect implements SupervisorDisconnectUsecase {
  constructor(private publisher: SupervisorDisconnectEventPublisher) {}

  async run(request: SupervisorDisconnectRequest): Promise<void> {
    await Promise.all([
      this.publisher.publish(
        request.call as PhoneCall,
        request.callId,
        request.agentNumber,
      ),
    ]);
  }
}
